module.exports = __webpack_public_path__ + "static/media/20ECE17.9a447e5e.jpg";